
import { Component, Vue } from 'vue-property-decorator';
import RechargeInfo from '@/shared/components/RechargeInfo.vue';
@Component({
  components: {
    'recharge-info': RechargeInfo
  }
})
export default class Recharge extends Vue {

}
